var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 174,
    viewBox: "0 0 145 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 173.762L71.274 140.789C70.5239 120.616 54.2849 104.438 34.0462 103.701L2.14922e-05 102.46L34.0462 101.22C54.2849 100.483 70.5239 84.3046 71.274 64.1318L72.5 31.1588L73.726 64.1318C74.4761 84.3046 90.7151 100.483 110.954 101.22L145 102.46L110.954 103.701C90.7151 104.438 74.4761 120.616 73.726 140.789L72.5 173.762Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.24 56.3223L115.753 43.2993C115.456 35.3319 109.014 28.9422 100.985 28.651L87.4793 28.1611L100.985 27.6712C109.014 27.38 115.456 20.9903 115.753 13.0229L116.24 -4.4476e-05L116.726 13.0229C117.024 20.9903 123.466 27.38 131.494 27.6712L145 28.1611L131.494 28.651C123.466 28.9422 117.024 35.3319 116.726 43.2993L116.24 56.3223Z",
    fill: "white",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.8f5a0175c5933d3d36f9eb1b44636627.svg";
export { ForwardRef as ReactComponent };